<template>
	<div class="m-portlet">
	    <div class="m-portlet__head">
			<date-range-picker 
		        pickerId="agent-report"
		        v-on:date-change="onDateRangeChange"
		    ></date-range-picker>
	    </div>
	    <div class="m-portlet__body">
			<div class="col-xl-3" style="padding-top:5px;">
				<!--begin:: Widgets/Product Sales-->
				<div class="m-portlet m-portlet--bordered-semi m-portlet--space m-portlet--full-height ">
					<div class="m-portlet__head" style="padding:0;height:2rem;">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text">
									Tổng thu về
								</h3>
							</div>
						</div>
					</div>
					<div class="m-portlet__body" style="padding: 0;">
						<div class="m-widget25">
							<span class="m-widget25__price m--font-brand">{{ totalSaleRev }}</span>
							<span class="m-widget25__desc">({{ totalSaleMonth }} tháng)</span>
						</div>
					</div>
				</div>
				<!--end:: Widgets/Product Sales-->
			</div>
			<div class="m-demo" data-code-preview="true" data-code-html="true" ref="rp_container" v-html="report" data-code-js="false">
			</div>
			<sale-detail
				:from="from" 
				:to="to"
			/>
	    </div>
	</div>
</template>

<script>
	import DateRangePicker from '../DateRangePicker';
	import SaleReportDetail from './SaleReportDetail';
	import { Utilities } from "../../utilities";

	export default {
		data() {
			return {
				"from": "",
				"to": "",
				"reportData" : [],
				"totalSale": 0,
				"totalSaleMonth": 0
			}
		},

		watch: {
			report: function(val){
				let vm = this;
				window.setTimeout(()=>{
					jQuery(this.$refs['rp_container']).find("a.player_sale").click((e) => {
						$('#report_sale_detail').attr("playerCode", $(e.currentTarget).attr("code"));
						$('#report_sale_detail').modal('show');
					});
				}, 1000);
			}
		},

		computed: {
			report :function(){
				let content = 	'<ul class="m-nav m-nav--active-bg" id="m_nav" role="tablist">';
				content += 			this.generate(this.reportData, 0, 0);
				content += 		'</ul>';

				return content;
			},
			totalSaleRev: function(){
				return Utilities.currencyFormat(this.totalSale);
			}
		},

		components:{
	        'date-range-picker': DateRangePicker,
	        'sale-detail': SaleReportDetail
	    },

		methods: {
			fetchData: async function(){
				let res = await axios.get("admin-panel/report/sale?from="+this.from+"&to="+this.to);
				res = res.data;

				if(res.code == 0){
					this.reportData = res.data;

					let totalSale = 0;
					let totalSaleMonth = 0;
					for(let i=0;i<res.data.length;i++){
						totalSale += res.data[i].pay;
						totalSaleMonth += res.data[i].life_time;
					}
					this.totalSale = totalSale;
					this.totalSaleMonth = totalSaleMonth;
				}
			},

			onDateRangeChange: function(start, end){
	            this.from = start;
	            this.to = end;

	            this.fetchData();
	        },

			generate: function(data, index, deep){
				let temp = "";
				if(!data) return "";

				for(let i=0;i<data.length;i++){
					let actCls = '';//(!!data[i].childs && data[i].childs.length > 0) ? 'm-nav__item--active' : '';
					let aAttr = (!!data[i].childs && data[i].childs.length > 0) ? ' id="m_nav_link_'+i+'_'+deep+'" role="tab" data-toggle="collapse" aria-expanded="false" ' : '';
					temp += '<li class="m-nav__item '+actCls+'">';
					let uname = data[i].fullname ? (data[i].code.toUpperCase() + ' ('+ data[i].fullname +')') : data[i].code.toUpperCase();

					if(data[i].code.length == 9){
						temp += '<a href="javascript:;" class="m-nav__link player_sale" code="'+data[i].code+'">';
					}else{
						temp += '<a href="#m_nav_sub_'+i+'_'+deep+'" '+aAttr+' class="m-nav__link">';
					}

					temp += 		'<i class="m-nav__link-icon flaticon-share"></i>';
					temp += 		'<span class="m-nav__link-title">' +
										'<span class="m-nav__link-wrap">' +
											'<span class="m-nav__link-text">'+ uname+'</span>' +
										'</span>' +
									'</span>' +
									'<span class="m-nav__link-badge">' +
										'<span class="m-badge m-badge--success m-badge--wide m-badge--rounded">Thanh toán '+data[i].life_time+' tháng (<span style="font-weight:bold;">'+ Utilities.currencyFormat(data[i].pay) +'</span>)</span>' +
									'</span>' ;

					// if(!!data[i].childs && data[i].childs.length > 0){
					// 	temp +=		'<span class="m-nav__link-arrow"></span>';
					// }
					
					temp += 	'</a>';

					if(!!data[i].childs && data[i].childs.length > 0){
						let parentCls = deep == 0 ? "m_nav" : ("m_nav_sub_"+index+"_" + (deep - 1));
						// if(i == 0){
						// 	temp += '<ul class="m-nav__sub collapse show" id="m_nav_sub_'+deep+'" role="tabpanel" aria-labelledby="m_nav_link_'+deep+'" data-parent="#'+parentCls+'">';
						// }else{
							temp += '<ul class="m-nav__sub collapse " id="m_nav_sub_'+i+'_'+deep+'" role="tabpanel" aria-labelledby="m_nav_link_'+i+'_'+deep+'" data-parent="#'+parentCls+'">';
						// }
						
						temp += this.generate(data[i].childs, i,deep + 1);
						temp += '</ul>';
					}

					temp += '</li>';
				}

				return temp;
			}
		}
	}
</script>

<style>
	span.m-nav__link-badge {
	    float: right;
	}
	.m-widget25 .m-widget25__price{
		font-size: 25px;
	}
</style>